import Geolocation from './components/_geolocation';
import GoogleMap from './components/_map';
import CustomPin from './components/_custom-pin';
import CustomPopup from './components/_custom-popup';
import {markerclusterSettings} from './include/_markerclustersSettings';
import './components/_toggle-filters';
import {mapStyle} from './include/_mapStyle';


window.initStoreLocator = () => {

  let initialPosition = new google.maps.LatLng(48.5189229, 7.736215000000016);

  StoreLocator.init({
    mapContainerSelector : '#store-locator',
    center : initialPosition,
    address : '',
    zoom : 12,
    streetViewControl: false,
    styles: mapStyle,
  });

  StoreLocator.setLocation(initialPosition.lat(), initialPosition.lng());

  let ac = new google.maps.places.Autocomplete(
    (document.getElementById('searching')),
    {
      types: ['geocode'],
      componentRestrictions: {country: "fr"},
    }
  );

  ac.addListener('place_changed', function() {
    let place = ac.getPlace();
    if (!place.geometry) {
      return;
    }
    for (let i = 0; i < place.address_components.length; i++) {
      for (let j = 0; j < place.address_components[i].types.length; j++) {
        if (place.address_components[i].types[j] == "postal_code") {
          document.querySelector('[js-selected-postal-code]').value = place.address_components[i].long_name;
        } else {
          document.querySelector('[js-selected-postal-code]').value = '';
        }
      }
    }
    StoreLocator.setLocation(place.geometry.location.lat(), place.geometry.location.lng());
  });

  var urlParams = new URLSearchParams(window.location.search);
  if(urlParams.has('open_product')) {
    setTimeout(() => {
      document.querySelector('[js-product-choose]').value = urlParams.get('open_product');
      document.querySelector('[js-product-choose]').dispatchEvent(new Event('change'));
    }, 200);

  }

};


document.querySelector('[js-geolocation]').addEventListener('click', () => {
  const geolocation = new Geolocation();
  geolocation.getCoords((result) => {
    if(result.success) {
      StoreLocator.setLocation(result.coords.latitude, result.coords.longitude);
      StoreLocator.renderGeolocation();
    }
  });
});

document.querySelector('[js-product-choose]').addEventListener('change', (event) => {
  StoreLocator.setProduct(event.target.value);
});

document.querySelector('[js-refresh-location]').addEventListener('click', (event) => {
  const diagonalDistance = distance(
    StoreLocator.getMapBounds().topLeft.lat(),
    StoreLocator.getMapBounds().topLeft.lng(),
    StoreLocator.getMapBounds().bottomRight.lat(),
    StoreLocator.getMapBounds().bottomRight.lng()
  );
  const radius = Math.round(diagonalDistance / 2.5);
  StoreLocator.setLocation(StoreLocator.getCenter().lat(), StoreLocator.getCenter().lng(), radius);
});


function distance(lat1,lon1,lat2,lon2) {
  const R = 6371; // km (change this constant to get miles)
  const dLat = (lat2-lat1) * Math.PI / 180;
  const dLon = (lon2-lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

let StoreLocator = (function(){

  let self = {};

  let model = {
    map : null,
    currentPosition: {
      lat : null,
      lng: null,
    },
    currentAddress : null,
    product : null,
    radius : 40,
    defaultRadius : 40,
    request : null,
    initialPosition : null,
  };


  let markers;
  let markerClusterer;
  let currentPin;

  self.init = (options) => {
    model.map = new GoogleMap(options);
    model.currentAddress = options.address;
    model.initialPosition = options.center;
  };

  self.setLocation = (lat, lng, radius = model.defaultRadius) => {

    updateModel({
      currentPosition: {
        lat: lat,
        lng: lng,
      },
      radius: radius
    });

  };

  self.setProduct = (product) => {
    console.log(product);
    updateModel({
      product: product
    });
  };

  self.getCenter = () => {
    return model.map.getCenter();
  };

  self.getMapBounds = () => {
    return {
      topLeft : model.map.getBounds().getNorthEast(),
      bottomRight : model.map.getBounds().getSouthWest()
    }
  };

  function updateModel( newModelDatas ) {
    model = Object.assign({}, model, newModelDatas);
    render();
  }

  function setMarkers(data) {

    markers = data.map(function(location, i) {

      const coords = new google.maps.LatLng(location.position.lat, location.position.lng);

      const marker = new CustomPin({
        latlng: coords,
        map: model.map,
        html: document.getElementById('template-store-pin').innerHTML,
        customCenterCoords: {x: 22.5, y: 46 }
      });

      const popup = new CustomPopup({
        position : coords,
        template : 'template-pop-up',
        content : {
          title : location.name,
          address : location.address,
          phone : location.phone,
          distance : location.distance,
          route : 'https://www.google.fr/maps/dir/'+encodeURIComponent(model.currentAddress)+'/'+encodeURIComponent(location.address)+'/'
        },
        map : model.map,
      });

      marker.addListener('click', function() {
        model.map.panTo(marker.getPosition());
        popup.open();
      });


      document.addEventListener('click', function(event) {
        if(event.target.closest('.' + marker.getClassName()) === null) {
          popup.close();
        }
      });

      return marker;

    });

    markerClusterer = new MarkerClusterer(model.map, markers, markerclusterSettings);

  }

  function removeMarkers() {

    if(markers) {
      for(let i=0; i < markers.length; i++){
        markers[i].setMap(null);
      }

      if(markerClusterer) {
        markerClusterer.clearMarkers();
      }

      markers = [];
    }

  }

  self.renderGeolocation= () => {

    const latLng = new google.maps.LatLng(model.currentPosition.lat, model.currentPosition.lng);

    let geocoder = new google.maps.Geocoder;
    // Don't put adress if it's the original position (for the google maps route link later)
    if((latLng.lat() !== model.initialPosition.lat()) && (latLng.lng() !== model.initialPosition.lng()) ) {
      geocoder.geocode({'location': latLng}, function(results) {
        model.currentAddress = results[0].formatted_address;
      });
    }


    if(currentPin) {
      currentPin.setMap(null);
    }

    model.map.panTo(latLng);
    currentPin = new CustomPin({
      latlng: latLng,
      map: model.map,
      html: document.getElementById('template-geolocation-pin').innerHTML
    });

  };

  function getStores(options, successCallback, errorCallback) {

    if(model.request) {
      model.request.abort();
    }

    document.querySelector('[js-stores-loader]').classList.add('displayed');

    let url = '/wp-json/store-locator/v1/locations?return=1';
    if(options.position.lat && options.position.lng) {
      url += '&lat='+ options.position.lat +'&lng='+ options.position.lng;
    }

    if(options.radius) {
      url += '&radius='+ options.radius;
    }

    if(options.product) {
      url += '&product='+ options.product;
    }

    model.request = new XMLHttpRequest();
    model.request.open('GET', url, true);

    model.request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        // Success!
        var data = JSON.parse(this.response);
        successCallback(data);

      } else {
        // We reached our target server, but it returned an error
        var data = JSON.parse(this.response);
        errorCallback(data);
      }

      model.request = null;
      document.querySelector('[js-stores-loader]').classList.remove('displayed');
    };

    model.request.onerror = function() {
      errorCallback({
        'error' : 'Error during the XHR process'
      });
      document.querySelector('[js-stores-loader]').classList.remove('displayed');
    };

    model.request.send();

  }

  function render() {

    removeMarkers();

    getStores(
      {
        position: model.currentPosition,
        product: model.product,
        radius: model.radius,
      },
      (locations) => {
        setMarkers(locations);
        model.map.panTo(model.currentPosition);
      },
      () => {

      }
    );
  }

  return self;

}());





// WEBPACK FOOTER //
// ./assets/scripts/map/store-locator.js